import { bindToBrand } from './utils/bind';
/**
 * Mapping of semantic tokens into the individual components, i.e., brand layer for the components.
 * Adds also default values from the Terveystalo brand.
 *
 * This is intended to be used in the component library.
 */
export const brand = {
    shared: {
        color: {
            focus: {
                outline: {
                    inner: bindToBrand('core.color.outline.positive.inner'),
                    outer: bindToBrand('core.color.outline.positive.outer'),
                },
            },
        },
    },
    box: {
        color: {
            background: bindToBrand('interaction.color.default.background'),
            border: bindToBrand('interaction.color.default.border'),
            shadow: bindToBrand('interaction.color.default.shadow'),
        },
        border: {
            radius: bindToBrand('core.border.xs.radius'),
        },
    },
    button: {
        font: {
            cta: {
                family: bindToBrand('cta.font.family'),
                weight: bindToBrand('cta.font.weight'),
                size: bindToBrand('cta.font.size'),
                lineHeight: bindToBrand('cta.font.lineHeight'),
                letterSpacing: bindToBrand('cta.font.letterSpacing'),
            },
            text: {
                family: bindToBrand('core.font.m.family'),
                weight: bindToBrand('core.font.m.weight'),
                size: bindToBrand('core.font.m.size'),
                lineHeight: bindToBrand('core.font.m.lineHeight'),
                letterSpacing: bindToBrand('core.font.m.letterSpacing'),
            },
            side: {
                family: bindToBrand('subHeading.font.xs.family'),
                weight: bindToBrand('subHeading.font.xs.weight'),
                size: bindToBrand('subHeading.font.xs.size'),
                lineHeight: bindToBrand('subHeading.font.xs.lineHeight'),
                letterSpacing: bindToBrand('subHeading.font.xs.letterSpacing'),
            },
        },
        border: {
            default: {
                radius: bindToBrand('core.border.xl.radius'),
            },
            side: {
                radius: bindToBrand('core.border.l.radius'),
            },
        },
        color: {
            primary: {
                positive: {
                    default: {
                        background: bindToBrand('cta.color.primary.positive.default.background'),
                        border: bindToBrand('cta.color.primary.positive.default.border'),
                        content: bindToBrand('cta.color.primary.positive.default.content'),
                        icon: bindToBrand('cta.color.primary.positive.default.content'),
                    },
                    hover: {
                        background: bindToBrand('cta.color.primary.positive.highlight.background'),
                        border: bindToBrand('cta.color.primary.positive.highlight.border'),
                        content: bindToBrand('cta.color.primary.positive.highlight.content'),
                        icon: bindToBrand('cta.color.primary.positive.highlight.content'),
                    },
                    disabled: {
                        background: bindToBrand('cta.color.primary.positive.muted.background'),
                        border: bindToBrand('cta.color.primary.positive.muted.border'),
                        content: bindToBrand('cta.color.primary.positive.muted.content'),
                        icon: bindToBrand('cta.color.primary.positive.muted.content'),
                    },
                    focus: {
                        outline: {
                            inner: bindToBrand('core.color.outline.positive.inner'),
                            outer: bindToBrand('core.color.outline.positive.outer'),
                        },
                    },
                },
                negative: {
                    default: {
                        background: bindToBrand('cta.color.primary.negative.default.background'),
                        border: bindToBrand('cta.color.primary.negative.default.border'),
                        content: bindToBrand('cta.color.primary.negative.default.content'),
                        icon: bindToBrand('cta.color.primary.negative.default.content'),
                    },
                    hover: {
                        background: bindToBrand('cta.color.primary.negative.highlight.background'),
                        border: bindToBrand('cta.color.primary.negative.highlight.border'),
                        content: bindToBrand('cta.color.primary.negative.highlight.content'),
                        icon: bindToBrand('cta.color.primary.negative.highlight.content'),
                    },
                    disabled: {
                        background: bindToBrand('cta.color.primary.negative.muted.background'),
                        border: bindToBrand('cta.color.primary.negative.muted.border'),
                        content: bindToBrand('cta.color.primary.negative.muted.content'),
                        icon: bindToBrand('cta.color.primary.negative.muted.content'),
                    },
                    focus: {
                        outline: {
                            inner: bindToBrand('core.color.outline.negative.inner'),
                            outer: bindToBrand('core.color.outline.negative.outer'),
                        },
                    },
                },
            },
            secondary: {
                positive: {
                    default: {
                        background: bindToBrand('cta.color.secondary.positive.default.background'),
                        border: bindToBrand('cta.color.secondary.positive.default.border'),
                        content: bindToBrand('cta.color.secondary.positive.default.content'),
                        icon: bindToBrand('cta.color.secondary.positive.default.content'),
                    },
                    hover: {
                        background: bindToBrand('cta.color.secondary.positive.highlight.background'),
                        border: bindToBrand('cta.color.secondary.positive.highlight.border'),
                        content: bindToBrand('cta.color.secondary.positive.highlight.content'),
                        icon: bindToBrand('cta.color.secondary.positive.highlight.content'),
                    },
                    disabled: {
                        background: bindToBrand('cta.color.secondary.positive.muted.background'),
                        border: bindToBrand('cta.color.secondary.positive.muted.border'),
                        content: bindToBrand('cta.color.secondary.positive.muted.content'),
                        icon: bindToBrand('cta.color.secondary.positive.muted.content'),
                    },
                    focus: {
                        outline: {
                            inner: bindToBrand('core.color.outline.positive.inner'),
                            outer: bindToBrand('core.color.outline.positive.outer'),
                        },
                    },
                },
                negative: {
                    default: {
                        background: bindToBrand('cta.color.secondary.negative.default.background'),
                        border: bindToBrand('cta.color.secondary.negative.default.border'),
                        content: bindToBrand('cta.color.secondary.negative.default.content'),
                        icon: bindToBrand('cta.color.secondary.negative.default.content'),
                    },
                    hover: {
                        background: bindToBrand('cta.color.secondary.negative.highlight.background'),
                        border: bindToBrand('cta.color.secondary.negative.highlight.border'),
                        content: bindToBrand('cta.color.secondary.negative.highlight.content'),
                        icon: bindToBrand('cta.color.secondary.negative.highlight.content'),
                    },
                    disabled: {
                        background: bindToBrand('cta.color.secondary.negative.muted.background'),
                        border: bindToBrand('cta.color.secondary.negative.muted.border'),
                        content: bindToBrand('cta.color.secondary.negative.muted.content'),
                        icon: bindToBrand('cta.color.secondary.negative.muted.content'),
                    },
                    focus: {
                        outline: {
                            inner: bindToBrand('core.color.outline.negative.inner'),
                            outer: bindToBrand('core.color.outline.negative.outer'),
                        },
                    },
                },
            },
            pill: {
                default: {
                    background: {
                        onDark: bindToBrand('forms.color.default.background.onDark'),
                        onLight: bindToBrand('forms.color.default.background.onLight'),
                    },
                    border: bindToBrand('cta.color.secondary.positive.default.border'),
                    content: bindToBrand('cta.color.secondary.positive.default.content'),
                    icon: bindToBrand('cta.color.secondary.positive.default.content'),
                },
                hover: {
                    background: bindToBrand('cta.color.secondary.positive.highlight.background'),
                    border: bindToBrand('cta.color.secondary.positive.highlight.border'),
                    content: bindToBrand('cta.color.secondary.positive.default.content'),
                    icon: bindToBrand('cta.color.secondary.positive.highlight.content'),
                },
                disabled: {
                    background: bindToBrand('cta.color.secondary.positive.muted.background'),
                    border: bindToBrand('cta.color.secondary.positive.muted.border'),
                    content: bindToBrand('cta.color.secondary.positive.muted.content'),
                    icon: bindToBrand('cta.color.secondary.positive.muted.content'),
                },
                focus: {
                    outline: {
                        inner: bindToBrand('core.color.outline.negative.inner'),
                        outer: bindToBrand('core.color.outline.negative.outer'),
                    },
                },
            },
            round: {
                default: {
                    background: bindToBrand('cta.color.secondary.positive.default.background'),
                    border: bindToBrand('cta.color.secondary.positive.default.background'),
                    content: bindToBrand('cta.color.secondary.positive.default.content'),
                    icon: bindToBrand('cta.color.secondary.positive.default.content'),
                },
                hover: {
                    background: bindToBrand('cta.color.secondary.positive.highlight.background'),
                    border: bindToBrand('cta.color.secondary.positive.highlight.border'),
                    content: bindToBrand('cta.color.secondary.positive.highlight.content'),
                    icon: bindToBrand('cta.color.secondary.positive.highlight.content'),
                },
                disabled: {
                    background: bindToBrand('cta.color.secondary.positive.muted.background'),
                    border: bindToBrand('cta.color.secondary.positive.muted.border'),
                    content: bindToBrand('cta.color.secondary.positive.muted.content'),
                    icon: bindToBrand('cta.color.secondary.positive.muted.content'),
                },
                focus: {
                    outline: {
                        inner: bindToBrand('core.color.outline.negative.inner'),
                        outer: bindToBrand('core.color.outline.negative.outer'),
                    },
                },
            },
            side: {
                default: {
                    background: bindToBrand('cta.color.primary.positive.default.background'),
                    border: bindToBrand('cta.color.primary.positive.default.border'),
                    content: bindToBrand('cta.color.primary.positive.default.content'),
                    icon: bindToBrand('cta.color.primary.positive.default.content'),
                    shadow: bindToBrand('interaction.color.default.shadow'),
                },
                hover: {
                    background: bindToBrand('cta.color.primary.positive.highlight.background'),
                    border: bindToBrand('cta.color.primary.positive.highlight.border'),
                    content: bindToBrand('cta.color.primary.positive.highlight.content'),
                    icon: bindToBrand('cta.color.primary.positive.highlight.content'),
                },
                disabled: {
                    background: bindToBrand('cta.color.primary.positive.muted.background'),
                    border: bindToBrand('cta.color.primary.positive.muted.border'),
                    content: bindToBrand('cta.color.primary.positive.muted.content'),
                    icon: bindToBrand('cta.color.primary.positive.muted.content'),
                },
                focus: {
                    outline: {
                        inner: bindToBrand('core.color.outline.negative.inner'),
                        outer: bindToBrand('core.color.outline.negative.outer'),
                    },
                },
            },
            text: {
                default: {
                    content: bindToBrand('cta.color.secondary.positive.default.content'),
                    icon: bindToBrand('cta.color.secondary.positive.default.content'),
                },
                hover: {
                    content: bindToBrand('cta.color.secondary.positive.highlight.content'),
                    border: bindToBrand('cta.color.secondary.positive.highlight.content'),
                    icon: bindToBrand('cta.color.secondary.positive.highlight.content'),
                },
                active: {
                    content: bindToBrand('cta.color.secondary.positive.default.content'),
                    border: bindToBrand('cta.color.secondary.positive.default.border'),
                    icon: bindToBrand('cta.color.secondary.positive.default.content'),
                },
                disabled: {
                    content: bindToBrand('cta.color.secondary.positive.muted.content'),
                    icon: bindToBrand('cta.color.secondary.positive.muted.content'),
                },
                focus: {
                    outline: {
                        inner: bindToBrand('core.color.outline.negative.inner'),
                        outer: bindToBrand('core.color.outline.negative.outer'),
                    },
                },
            },
        },
    },
    link: {
        color: {
            default: {
                content: bindToBrand('cta.color.link.default.content'),
            },
            hover: {
                content: bindToBrand('cta.color.link.default.content'),
            },
            visited: {
                content: bindToBrand('cta.color.link.default.content'),
            },
        },
    },
    formControl: {
        border: {
            radius: bindToBrand('core.border.l.radius'),
        },
        color: {
            default: {
                background: {
                    onDark: bindToBrand('forms.color.default.background.onDark'),
                    onLight: bindToBrand('forms.color.default.background.onLight'),
                },
                content: bindToBrand('forms.color.default.content'),
                border: bindToBrand('interaction.color.default.border'),
            },
            hover: {
                outline: bindToBrand('forms.color.selected.border'),
            },
            active: {
                outline: bindToBrand('forms.color.selected.border'),
            },
            invalid: {
                outline: bindToBrand('forms.color.error.content'),
                content: bindToBrand('forms.color.error.content'),
            },
            disabled: {
                content: bindToBrand('forms.color.muted.content'),
            },
            error: {
                background: bindToBrand('forms.color.error.background'),
                content: bindToBrand('forms.color.invalid.content'),
            },
            warning: {
                background: bindToBrand('forms.color.warning.background'),
                border: bindToBrand('forms.color.warning.border'),
                content: bindToBrand('forms.color.warning.content'),
            },
        },
    },
    checkbox: {
        border: {
            radius: bindToBrand('core.border.s.radius'),
        },
        color: {
            default: {
                background: {
                    onDark: bindToBrand('forms.color.default.background.onDark'),
                    onLight: bindToBrand('forms.color.default.background.onLight'),
                },
                border: bindToBrand('forms.color.default.border'),
                content: bindToBrand('forms.color.default.content'),
            },
            checked: {
                background: bindToBrand('forms.color.selected.background'),
                content: bindToBrand('forms.color.selected.content'),
                border: bindToBrand('forms.color.selected.border'),
            },
            disabled: {
                background: bindToBrand('forms.color.muted.background'),
                border: bindToBrand('forms.color.muted.border'),
                checked: {
                    background: bindToBrand('forms.color.muted.content'),
                },
            },
            focus: {
                outline: {
                    inner: bindToBrand('core.color.outline.negative.inner'),
                    outer: bindToBrand('core.color.outline.negative.outer'),
                },
            },
        },
    },
    radio: {
        border: {
            radius: bindToBrand('core.border.xl.radius'),
        },
        color: {
            default: {
                background: {
                    onDark: bindToBrand('forms.color.default.background.onDark'),
                    onLight: bindToBrand('forms.color.default.background.onLight'),
                },
                border: bindToBrand('forms.color.default.border'),
                content: bindToBrand('forms.color.default.content'),
            },
            checked: {
                background: bindToBrand('forms.color.selected.background'),
                border: bindToBrand('forms.color.selected.border'),
                content: bindToBrand('forms.color.selected.content'),
            },
            disabled: {
                background: bindToBrand('forms.color.muted.background'),
                border: bindToBrand('forms.color.muted.border'),
                checked: {
                    background: bindToBrand('forms.color.muted.content'),
                },
            },
            focus: {
                outline: {
                    inner: bindToBrand('core.color.outline.negative.inner'),
                    outer: bindToBrand('core.color.outline.negative.outer'),
                },
            },
        },
    },
    select: {
        font: {
            family: bindToBrand('core.font.m.family'),
            weight: bindToBrand('core.font.m.weight'),
            size: bindToBrand('core.font.m.size'),
            lineHeight: bindToBrand('core.font.m.lineHeight'),
            letterSpacing: bindToBrand('core.font.m.letterSpacing'),
        },
        border: {
            radius: bindToBrand('core.border.l.radius'),
        },
        color: {
            default: {
                background: {
                    onDark: bindToBrand('forms.color.default.background.onDark'),
                    onLight: bindToBrand('forms.color.default.background.onLight'),
                },
                border: bindToBrand('interaction.color.default.border'),
            },
            active: {
                border: bindToBrand('forms.color.selected.border'),
            },
            disabled: {
                content: bindToBrand('forms.color.muted.content'),
            },
        },
    },
    textField: {
        font: {
            family: bindToBrand('core.font.m.family'),
            weight: bindToBrand('core.font.m.weight'),
            size: bindToBrand('core.font.m.size'),
            lineHeight: bindToBrand('core.font.m.lineHeight'),
            letterSpacing: bindToBrand('core.font.m.letterSpacing'),
        },
        border: {
            radius: bindToBrand('core.border.m.radius'),
        },
        color: {
            default: {
                background: {
                    onDark: bindToBrand('forms.color.default.background.onDark'),
                    onLight: bindToBrand('forms.color.default.background.onLight'),
                },
                content: bindToBrand('forms.color.default.content'),
                border: bindToBrand('forms.color.muted.content'),
            },
            active: {
                border: bindToBrand('forms.color.selected.border'),
            },
            disabled: {
                content: bindToBrand('forms.color.muted.content'),
                border: bindToBrand('forms.color.muted.background'),
                icon: bindToBrand('forms.color.muted.content'),
            },
            invalid: {
                border: bindToBrand('forms.color.error.content'),
                content: bindToBrand('forms.color.error.content'),
            },
            success: {
                content: bindToBrand('forms.color.success.content'),
            },
        },
    },
    skeleton: {
        border: {
            radius: bindToBrand('core.border.xs.radius'),
        },
        color: {
            default: {
                background: bindToBrand('feedback.color.loading.background'),
                content: {
                    neutral: bindToBrand('feedback.color.loading.background'),
                    accent: bindToBrand('feedback.color.loading.content'),
                },
            },
        },
    },
    switch: {
        border: {
            radius: {
                inner: bindToBrand('core.border.xl.radius'),
                outer: bindToBrand('core.border.xl.radius'),
            },
        },
        color: {
            default: {
                background: bindToBrand('forms.color.muted.content'),
                content: bindToBrand('forms.color.default.background.onLight'),
            },
            focus: {
                outline: bindToBrand('core.color.outline.positive.outer'),
            },
            checked: {
                background: bindToBrand('forms.color.selected.background'),
            },
        },
    },
    title: {
        color: {
            default: {
                content: bindToBrand('heading.color.content'),
            },
        },
        font: {
            xxxl: {
                family: bindToBrand('heading.font.xxxl.family'),
                weight: bindToBrand('heading.font.xxxl.weight'),
                size: bindToBrand('heading.font.xxxl.size'),
                lineHeight: bindToBrand('heading.font.xxxl.lineHeight'),
                letterSpacing: bindToBrand('heading.font.xxxl.letterSpacing'),
            },
            xxl: {
                family: bindToBrand('heading.font.xxl.family'),
                weight: bindToBrand('heading.font.xxl.weight'),
                size: bindToBrand('heading.font.xxl.size'),
                lineHeight: bindToBrand('heading.font.xxl.lineHeight'),
                letterSpacing: bindToBrand('heading.font.xxl.letterSpacing'),
            },
            xl: {
                family: bindToBrand('heading.font.xl.family'),
                weight: bindToBrand('heading.font.xl.weight'),
                size: bindToBrand('heading.font.xl.size'),
                lineHeight: bindToBrand('heading.font.xl.lineHeight'),
                letterSpacing: bindToBrand('heading.font.xl.letterSpacing'),
            },
            l: {
                family: bindToBrand('heading.font.l.family'),
                weight: bindToBrand('heading.font.l.weight'),
                size: bindToBrand('heading.font.l.size'),
                lineHeight: bindToBrand('heading.font.l.lineHeight'),
                letterSpacing: bindToBrand('heading.font.l.letterSpacing'),
            },
        },
    },
    subtitle: {
        color: {
            default: {
                content: bindToBrand('subHeading.color.content'),
            },
        },
        font: {
            xxl: {
                family: bindToBrand('subHeading.font.xxl.family'),
                weight: bindToBrand('subHeading.font.xxl.weight'),
                size: bindToBrand('subHeading.font.xxl.size'),
                lineHeight: bindToBrand('subHeading.font.xxl.lineHeight'),
                letterSpacing: bindToBrand('subHeading.font.xxl.family'),
            },
            xl: {
                family: bindToBrand('subHeading.font.xl.family'),
                weight: bindToBrand('subHeading.font.xl.weight'),
                size: bindToBrand('subHeading.font.xl.size'),
                lineHeight: bindToBrand('subHeading.font.xl.lineHeight'),
                letterSpacing: bindToBrand('subHeading.font.xl.letterSpacing'),
            },
            l: {
                family: bindToBrand('subHeading.font.l.family'),
                weight: bindToBrand('subHeading.font.l.weight'),
                size: bindToBrand('subHeading.font.l.size'),
                lineHeight: bindToBrand('subHeading.font.l.lineHeight'),
                letterSpacing: bindToBrand('subHeading.font.l.letterSpacing'),
            },
            mplus: {
                family: bindToBrand('subHeading.font.mplus.family'),
                weight: bindToBrand('subHeading.font.mplus.weight'),
                size: bindToBrand('subHeading.font.mplus.size'),
                lineHeight: bindToBrand('subHeading.font.mplus.lineHeight'),
                letterSpacing: bindToBrand('subHeading.font.mplus.letterSpacing'),
            },
            m: {
                family: bindToBrand('subHeading.font.m.family'),
                weight: bindToBrand('subHeading.font.m.weight'),
                size: bindToBrand('subHeading.font.m.size'),
                lineHeight: bindToBrand('subHeading.font.m.lineHeight'),
                letterSpacing: bindToBrand('subHeading.font.m.letterSpacing'),
            },
            s: {
                family: bindToBrand('subHeading.font.s.family'),
                weight: bindToBrand('subHeading.font.s.weight'),
                size: bindToBrand('subHeading.font.s.size'),
                lineHeight: bindToBrand('subHeading.font.s.lineHeight'),
                letterSpacing: bindToBrand('subHeading.font.s.letterSpacing'),
            },
            xs: {
                family: bindToBrand('subHeading.font.xs.family'),
                weight: bindToBrand('subHeading.font.xs.weight'),
                size: bindToBrand('subHeading.font.xs.size'),
                lineHeight: bindToBrand('subHeading.font.xs.lineHeight'),
                letterSpacing: bindToBrand('subHeading.font.xs.letterSpacing'),
            },
        },
    },
    body: {
        color: {
            default: {
                content: bindToBrand('core.color.content'),
            },
        },
        font: {
            l: {
                family: bindToBrand('core.font.l.family'),
                weight: bindToBrand('core.font.l.weight'),
                size: bindToBrand('core.font.l.size'),
                lineHeight: bindToBrand('core.font.l.lineHeight'),
                letterSpacing: bindToBrand('core.font.l.letterSpacing'),
            },
            m: {
                family: bindToBrand('core.font.m.family'),
                weight: bindToBrand('core.font.m.weight'),
                size: bindToBrand('core.font.m.size'),
                lineHeight: bindToBrand('core.font.m.lineHeight'),
                letterSpacing: bindToBrand('core.font.m.letterSpacing'),
            },
        },
    },
    lead: {
        color: {
            default: {
                content: bindToBrand('core.color.content'),
            },
        },
        font: {
            m: {
                family: bindToBrand('lead.font.m.family'),
                weight: bindToBrand('lead.font.m.weight'),
                size: bindToBrand('lead.font.m.size'),
                lineHeight: bindToBrand('lead.font.m.lineHeight'),
                letterSpacing: bindToBrand('lead.font.m.letterSpacing'),
            },
            s: {
                family: bindToBrand('lead.font.s.family'),
                weight: bindToBrand('lead.font.s.weight'),
                size: bindToBrand('lead.font.s.size'),
                lineHeight: bindToBrand('lead.font.s.lineHeight'),
                letterSpacing: bindToBrand('lead.font.s.letterSpacing'),
            },
        },
    },
    list: {
        font: {
            marker: {
                family: bindToBrand('list.font.marker.family'),
                weight: bindToBrand('list.font.marker.weight'),
                size: bindToBrand('list.font.marker.size'),
                lineHeight: bindToBrand('list.font.marker.lineHeight'),
                letterSpacing: bindToBrand('list.font.marker.letterSpacing'),
            },
            item: {
                family: bindToBrand('list.font.item.family'),
                weight: bindToBrand('list.font.item.weight'),
                size: bindToBrand('list.font.item.size'),
                lineHeight: bindToBrand('list.font.item.lineHeight'),
                letterSpacing: bindToBrand('list.font.item.letterSpacing'),
            },
        },
        color: {
            default: {
                border: bindToBrand('list.color.default.border'),
                marker: {
                    content: bindToBrand('list.color.default.marker.content'),
                },
                item: {
                    content: bindToBrand('list.color.default.item.content'),
                },
            },
            focus: {
                outline: {
                    inner: bindToBrand('core.color.outline.negative.inner'),
                    outer: bindToBrand('core.color.outline.negative.outer'),
                },
            },
            hover: {
                background: {
                    onLight: bindToBrand('list.color.default.background.onLight'),
                    onDark: bindToBrand('list.color.default.background.onDark'),
                },
            },
            disabled: {
                content: bindToBrand('list.color.muted.content'),
            },
        },
    },
    headerButton: {
        color: {
            positive: {
                default: {
                    background: bindToBrand('cta.color.primary.positive.default.background'),
                    content: bindToBrand('cta.color.primary.positive.default.content'),
                },
                hover: {
                    background: bindToBrand('navigation.color.highlight.content.onLight'),
                },
                active: {
                    background: bindToBrand('navigation.color.highlight.content.onDark'),
                    icon: bindToBrand('navigation.color.highlight.background'),
                },
                focus: {
                    outline: {
                        inner: bindToBrand('core.color.outline.positive.inner'),
                        outer: bindToBrand('core.color.outline.positive.outer'),
                    },
                },
            },
            negative: {
                default: {
                    background: bindToBrand('cta.color.primary.negative.default.background'),
                    content: bindToBrand('cta.color.primary.negative.default.content'),
                },
                hover: {
                    background: bindToBrand('navigation.color.highlight.background'),
                },
                active: {
                    background: bindToBrand('navigation.color.highlight.background'),
                    content: bindToBrand('navigation.color.highlight.content.onLight'),
                    icon: bindToBrand('navigation.color.highlight.content.onLight'),
                },
                focus: {
                    outline: {
                        inner: bindToBrand('core.color.outline.negative.inner'),
                        outer: bindToBrand('core.color.outline.negative.outer'),
                    },
                },
            },
        },
    },
    header: {
        color: {
            background: bindToBrand('navigation.color.default.background'),
            content: {
                onLight: bindToBrand('navigation.color.default.content.onLight'),
                onDark: bindToBrand('navigation.color.default.content.onDark'),
            },
            shadow: bindToBrand('navigation.color.default.shadow'),
            border: bindToBrand('navigation.color.default.border'),
        },
    },
    headerTitle: {
        color: {
            content: bindToBrand('cta.color.secondary.positive.highlight.background'),
        },
    },
    headerMenu: {
        color: {
            border: bindToBrand('navigation.color.default.border'),
            background: bindToBrand('interaction.color.default.background'),
        },
    },
    dialog: {
        border: {
            radius: bindToBrand('core.border.l.radius'),
        },
        color: {
            overlay: bindToBrand('interaction.color.default.overlay'),
            background: bindToBrand('interaction.color.default.background'),
            shadow: bindToBrand('interaction.color.default.shadow'),
            shadowLarge: bindToBrand('interaction.color.default.shadowLarge'),
            icon: bindToBrand('interaction.color.highlight.content'),
            border: bindToBrand('interaction.color.default.border'),
        },
    },
    menuItem: {
        color: {
            active: {
                background: bindToBrand('navigation.color.highlight.background'),
                content: bindToBrand('navigation.color.highlight.content.onLight'),
            },
        },
    },
    smiley: {
        border: {
            radius: bindToBrand('core.border.xl.radius'),
        },
        color: {
            border: bindToBrand('core.color.content'),
            content: bindToBrand('core.color.content'),
        },
    },
    alert: {
        color: {
            success: {
                background: bindToBrand('feedback.color.success.background'),
                content: bindToBrand('feedback.color.success.content'),
                border: bindToBrand('feedback.color.success.border'),
            },
            warning: {
                background: bindToBrand('feedback.color.warning.background'),
                content: bindToBrand('feedback.color.warning.content'),
                border: bindToBrand('feedback.color.warning.border'),
            },
            error: {
                background: bindToBrand('feedback.color.error.background'),
                content: bindToBrand('feedback.color.error.content'),
                border: bindToBrand('feedback.color.error.border'),
            },
            info: {
                background: bindToBrand('feedback.color.info.background'),
                content: bindToBrand('feedback.color.info.content'),
                border: bindToBrand('feedback.color.info.border'),
            },
        },
    },
    step: {
        color: {
            complete: {
                content: bindToBrand('forms.color.success.content'),
            },
            active: {
                content: bindToBrand('cta.color.link.default.content'),
            },
            upcoming: {
                content: bindToBrand('forms.color.muted.content'),
            },
        },
    },
    imageBesideContentBlock: {
        color: {
            background: bindToBrand('feedback.color.info.background'),
        },
    },
    footer: {
        color: {
            background: bindToBrand('interaction.color.default.background'),
        },
    },
    copyright: {
        color: {
            background: bindToBrand('core.color.background'),
        },
    },
    languageSelection: {
        border: {
            radius: bindToBrand('core.border.xl.radius'),
        },
        color: {
            default: {
                content: bindToBrand('navigation.color.default.background'),
            },
            hover: {
                background: bindToBrand('navigation.color.default.border'),
            },
            active: {
                content: bindToBrand('navigation.color.highlight.content.onLight'),
            },
        },
    },
    superMarsu: {
        font: {
            family: bindToBrand('core.font.m.family'),
            weight: bindToBrand('core.font.m.weight'),
        },
        color: {
            background: bindToBrand('cta.color.primary.positive.default.background'),
            content: bindToBrand('cta.color.primary.positive.default.content'),
        },
    },
    appPromo: {
        color: {
            background: bindToBrand('interaction.color.default.background'),
        },
    },
    feedbackRadioInput: {
        color: {
            default: {
                border: bindToBrand('forms.color.default.content'),
            },
            hover: {
                border: bindToBrand('forms.color.selected.border'),
            },
            focus: {
                outline: {
                    inner: bindToBrand('forms.color.selected.content'),
                    outer: bindToBrand('forms.color.selected.border'),
                },
            },
        },
    },
    feedbackLabel: {
        color: {
            veryNegative: bindToBrand('feedback.color.veryNegative'),
            negative: bindToBrand('feedback.color.negative'),
            neutral: bindToBrand('feedback.color.neutral.background'),
            positive: bindToBrand('feedback.color.positive'),
            veryPositive: bindToBrand('feedback.color.veryPositive'),
        },
    },
    card: {
        border: {
            radius: bindToBrand('core.border.m.radius'),
        },
        color: {
            normal: {
                default: {
                    background: bindToBrand('interaction.color.default.background'),
                    content: bindToBrand('interaction.color.default.content'),
                },
                hover: {
                    border: bindToBrand('interaction.color.highlight.content'),
                },
                focus: {
                    border: bindToBrand('core.color.outline.positive.outer'),
                },
            },
            featured: {
                default: {
                    background: bindToBrand('cta.color.primary.positive.default.background'),
                    content: bindToBrand('cta.color.primary.positive.default.content'),
                },
                hover: {
                    background: bindToBrand('cta.color.primary.positive.highlight.background'),
                },
                focus: {
                    outline: {
                        inner: bindToBrand('core.color.outline.positive.inner'),
                        outer: bindToBrand('core.color.outline.positive.outer'),
                    },
                },
            },
        },
    },
    cardTitle: {
        color: {
            normal: {
                border: bindToBrand('list.color.default.item.border'),
            },
            featured: {
                border: bindToBrand('navigation.color.default.border'),
            },
        },
    },
    roundImage: {
        color: {
            background: bindToBrand('interaction.color.muted.content'),
            content: bindToBrand('interaction.color.default.background'),
        },
    },
    status: {
        border: {
            radius: bindToBrand('core.border.m.radius'),
        },
        color: {
            info: {
                background: bindToBrand('feedback.color.info.background'),
                content: bindToBrand('feedback.color.info.content'),
            },
            warning: {
                background: bindToBrand('feedback.color.warning.background'),
                content: bindToBrand('feedback.color.warning.content'),
            },
            success: {
                background: bindToBrand('feedback.color.success.background'),
                content: bindToBrand('feedback.color.success.content'),
            },
            error: {
                background: bindToBrand('feedback.color.error.background'),
                content: bindToBrand('feedback.color.error.content'),
            },
            muted: {
                background: bindToBrand('feedback.color.neutral.background'),
                content: bindToBrand('feedback.color.neutral.content'),
            },
            cta: {
                default: {
                    background: bindToBrand('cta.color.primary.positive.default.background'),
                    content: bindToBrand('cta.color.primary.positive.default.content'),
                },
                hover: {
                    background: bindToBrand('cta.color.primary.positive.highlight.background'),
                },
            },
            ctaFeatured: {
                default: {
                    background: bindToBrand('cta.color.secondary.positive.default.background'),
                    content: bindToBrand('cta.color.secondary.positive.default.content'),
                },
                hover: {
                    background: bindToBrand('cta.color.secondary.positive.highlight.background'),
                    content: bindToBrand('cta.color.secondary.positive.highlight.content'),
                },
            },
        },
    },
    popover: {
        color: {
            background: bindToBrand('feedback.color.info.background'),
            content: bindToBrand('core.color.content'),
        },
    },
};
